'use client'

import { type ComponentType, useEffect, useRef, useState } from 'react'

import type { RelatedProductsProps } from './related-products'

export const RelatedProductsLazy = (props: RelatedProductsProps) => {
  const ref = useRef<HTMLDivElement>(null)
  const [shouldLoad, setShouldLoad] = useState(false)
  const [RelatedProductsClient, setRelatedProductsClient] = useState<ComponentType<RelatedProductsProps> | null>(null)

  useEffect(() => {
    if (shouldLoad) return

    const el = ref.current
    if (!el || !('IntersectionObserver' in window)) {
      setShouldLoad(true)
      return
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry?.isIntersecting) {
          setShouldLoad(true)
          observer.disconnect()
        }
      },
      { rootMargin: '900px 0px' }
    )

    observer.observe(el)
    return () => observer.disconnect()
  }, [shouldLoad])

  useEffect(() => {
    if (!shouldLoad || RelatedProductsClient) return

    let cancelled = false
    void import('./related-products').then((m) => {
      if (!cancelled) {
        setRelatedProductsClient(() => m.RelatedProductsClient)
      }
    })

    return () => {
      cancelled = true
    }
  }, [RelatedProductsClient, shouldLoad])

  return <div ref={ref}>{RelatedProductsClient ? <RelatedProductsClient {...props} /> : null}</div>
}
